// Curated list of luxury watch brands shown in catalog filters & admin dropdown.
// Keep alphabetically sorted (within each major group).
export const LUXURY_BRANDS = [
  'A. Lange & Söhne',
  'Audemars Piguet',
  'Bell & Ross',
  'Blancpain',
  'Breguet',
  'Breitling',
  'Bulgari',
  'Cartier',
  'Chopard',
  'F.P. Journe',
  'Franck Muller',
  'Girard-Perregaux',
  'Glashütte Original',
  'Grand Seiko',
  'H. Moser & Cie.',
  'Hublot',
  'IWC Schaffhausen',
  'Jaeger-LeCoultre',
  'Longines',
  'MB&F',
  'Montblanc',
  'Omega',
  'Panerai',
  'Patek Philippe',
  'Piaget',
  'Richard Mille',
  'Roger Dubuis',
  'Rolex',
  'TAG Heuer',
  'Tudor',
  'Ulysse Nardin',
  'Vacheron Constantin',
  'Zenith',
];
